import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Row, Skeleton } from "antd";
import moment from "moment";

import commentApi from "../../../apis/Comment.api";

const DashboardComments = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);

	const [commentList, setCommentList] = useState([]);

	useEffect(() => {
		if (user?.id) {
			getCommentList();
		}
	}, [user]);

	const getCommentList = async () => {
		setLoading(true);
		const param = {
			offset: 0,
			pageSize: 3,
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			answerStatus: 1,
			category: "all",
			searchWord: "",
		};
		const res = await commentApi.adminReadComment(param);
		if (res.code === 200) {
			setCommentList(res.result?.commentDTOList);
		}
		setLoading(false);
	};

	const convertCategory = (item) => {
		if (item?.category_type === "ingredient") {
			return `성분별 > ${item.category_name}`;
		} else if (item?.category_type === "function") {
			return `고민별 > ${item.category_name}`;
		} else if (item?.category_type === "combination") {
			return `조합별 > ${item.category_name}`;
		} else if (item?.category_type === "community") {
			return `소통`;
		}
	};

	return (
		<div className={`dashboard-body-each`}>
			<h2 className={`dashboard-each-title`}>
				최신 댓글
				<p className={`dashboard-each-title-description`}>
					내가 응답하지 않은 댓글
				</p>
			</h2>
			{commentList?.length ? (
				<div className={`dashboard-comments-list-div`}>
					{commentList?.map((comment, idx) => (
						<div
							className={`dashboard-comment-each`}
							key={`comment-each-${idx}`}
							style={
								idx === 0
									? {
											paddingTop: 0,
									  }
									: {}
							}
						>
							<div className={`comment-information`}>
								<p>{comment?.created_by_name}</p>
								<p>ㆍ</p>
								<p>
									{moment(moment(comment?.created_at), "YYYY.MM.DD").fromNow()}
								</p>
								<p className={`comment-parents-circle`}>
									{convertCategory(comment)}
								</p>
							</div>
							<p className={`comment-text`}>{comment?.content}</p>
						</div>
					))}
				</div>
			) : !loading ? (
				<>
					<Row
						align={"middle"}
						style={{ width: "100%", flexDirection: "column", padding: "3em 0" }}
					>
						<img
							src={`/assets/images/warning.png`}
							alt={`warning-icon`}
							style={{
								width: "3.5em",
								height: "auto",
							}}
						/>
						<span
							style={{
								marginTop: "1em",
								color: "#adb5bd",
								fontSize: "1.2em",
								fontWeight: 500,
							}}
						>
							작성된 댓글이 없습니다.
						</span>
					</Row>
				</>
			) : (
				<>
					<Skeleton.Button
						active={loading}
						size={"large"}
						block={true}
						style={{
							height: "3em",
						}}
					/>
					<Skeleton.Button
						active={loading}
						size={"large"}
						block={true}
						style={{
							height: "3em",
						}}
					/>
					<Skeleton.Button
						active={loading}
						size={"large"}
						block={true}
						style={{
							height: "3em",
						}}
					/>
				</>
			)}
			<Link to={"/user_comment_manage"}>댓글 관리로 이동</Link>
		</div>
	);
};

export default DashboardComments;
